import React from 'react';

const TransactionCompletedStatusIcon = ({ fontSize = 'medium', ...props }) => {
  const sizeMap = {
    small: 20,
    medium: 24,
    large: 28
  };

  const size = sizeMap[fontSize] || 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.8125 12.5C19.8125 7.90913 16.0909 4.1875 11.5 4.1875C6.90913 4.1875 3.1875 7.90913 3.1875 12.5C3.1875 17.0909 6.90913 20.8125 11.5 20.8125C16.0909 20.8125 19.8125 17.0909 19.8125 12.5ZM21 12.5C21 17.7467 16.7467 22 11.5 22C6.25329 22 2 17.7467 2 12.5C2 7.25329 6.25329 3 11.5 3C16.7467 3 21 7.25329 21 12.5Z"
        fill="#077F4E"
      />
      <path
        d="M15.3397 7.5125C15.6676 7.51258 15.9335 7.77838 15.9335 8.10625C15.9335 8.43412 15.6676 8.69992 15.3397 8.7H7.66042C7.3325 8.7 7.06667 8.43417 7.06667 8.10625C7.06667 7.77833 7.3325 7.5125 7.66042 7.5125H15.3397Z"
        fill="#077F4E"
      />
      <path
        d="M10.9062 18.2792V8.10625C10.9062 7.77833 11.1721 7.5125 11.5 7.5125C11.8279 7.5125 12.0938 7.77833 12.0938 8.10625V18.2792C12.0937 18.6071 11.8279 18.873 11.5 18.873C11.1721 18.873 10.9063 18.6071 10.9062 18.2792Z"
        fill="#077F4E"
      />
    </svg>
  );
};

export default TransactionCompletedStatusIcon;
